<template>
  <section>
    <div class="search-content">
      <el-row :gutter="20">
<!--        <el-col :span="14">-->
<!--          <el-button class="search-btn" size="small" type="search" icon="el-icon-search" @click="handleSearchDialog">筛选</el-button>-->
<!--        </el-col>-->
        <el-col :offset="14" :span="10" style="text-align: right;">
          <el-button class="search-btn" size="small" type="main" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-content">
      <el-table
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%;margin-top:20px">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          prop="enterpriseName"
          label="企业名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="enterpriseCode"
          width="180"
          label="企业代码">
        </el-table-column>
        <el-table-column
          prop="appealType"
          label="诉求类型"
          width="80"
          :formatter="appealTypeFormatter">
        </el-table-column>
        <el-table-column
          prop="delayStatus"
          label="状态"
          width="80"
          :formatter="delayStatusFormatter">
        </el-table-column>
        <el-table-column
          prop="appealContent"
          label="诉求事项"
          :formatter="contentFormatter"
          width="180">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="100">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="user.role==='admin'" type="main" size="mini" icon="el-icon-edit-outline" @click="handleVerify(scope.$index, scope.row)">审核</el-button>
            <el-button type="success" size="mini" icon="el-icon-view" @click="handleDelayView(scope.$index, scope.row)">延期报告</el-button>
            <el-button type="success" size="mini" icon="el-icon-view" @click="handleDetail(scope.$index, scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog title="详情" width="75%" :visible.sync="handleDetailInfoVisible" :close-on-click-modal="false">
      <el-form :model="handleDetailInfo" label-width="150px">
        <span class="payInfoTag">投诉方信息</span>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="12">
            <el-form-item label="企业名称：" prop="enterpriseName">
              <el-input v-model="handleDetailInfo.enterpriseName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="enterpriseCode">
              <el-input v-model="handleDetailInfo.enterpriseCode" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业所在园区：" prop="parkName">
              <el-input v-model="handleDetailInfo.parkName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业规模：" prop="enterpriseSize">
              <el-select v-model="handleDetailInfo.enterpriseSize" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in enterpriseSizeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业性质：" prop="enterpriseType">
              <el-select v-model="handleDetailInfo.enterpriseType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in enterpriseTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业行业：" prop="enterpriseIndustry" :disabled="true">
              <el-select v-model="handleDetailInfo.enterpriseIndustry" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in enterpriseIndustryList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目金额：" prop="amount">
              <el-input maxlength="50" v-model="handleDetailInfo.amount" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="拖欠类型：" prop="appealType">
              <el-select v-model="handleDetailInfo.appealType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in appealPayTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业联系人：" prop="contactPerson">
              <el-input v-model="handleDetailInfo.contactPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="contact">
              <el-input v-model="handleDetailInfo.contact" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系邮箱：" prop="email">
              <el-input maxlength="150" v-model="handleDetailInfo.email" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="诉求主要涉及单位：" prop="organizationNames">
              <el-input v-model="handleDetailInfo.organizationNames" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <span class="payInfoTag">被投诉方信息</span>
        <el-row :gutter="10" style="margin-top: 15px">
          <el-col :span="12">
            <el-form-item label="单位/企业名称：" prop="antiEnterpriseName">
              <el-input v-model="handleDetailInfo.antiEnterpriseName" maxlength="250" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="antiEnterpriseCode">
              <el-input v-model="handleDetailInfo.antiEnterpriseCode" maxlength="20" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="被投诉方所在地：" prop="antiAddress">
              <el-input v-model="handleDetailInfo.antiAddress" maxlength="200" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位/企业性质：" prop="antiEnterpriseType">
              <el-select v-model="handleDetailInfo.antiEnterpriseType" placeholder="请选择" style="width:100%" :disabled="true">
                <el-option
                  v-for="item in antiEnterpriseTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人：" prop="antiContactPerson">
              <el-input maxlength="50" v-model="handleDetailInfo.antiContactPerson" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="antiContact">
              <el-input maxlength="50" v-model="handleDetailInfo.antiContact" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="诉求事项说明：" prop="appealContent">
              <el-input v-model="handleDetailInfo.appealContent" type="textarea" :rows="6" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="相关附件：">
              <div v-for="file in appealFile">
                <el-link :underline="false" type="info" :href="file.fileUrl" target="_blank">{{file.fileName}}</el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="handleDetailInfo" style="border-top: 1px solid #888888;padding-top: 15px;" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="第一环节处理人：">
              <el-input v-model="handleDetailInfo.firstName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="第一环节处理时间：">
              <el-input v-model="handleDetailInfo.deliveryTime" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="第一环节处理意见：">
              <el-input v-model="handleDetailInfo.deliveryComment" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="处理单位：" prop="organizationNames">
              <el-input v-model="handleDetailInfo.organizationNames" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="第二环节处理人：">
              <el-input v-model="handleDetailInfo.secondName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="第二环节处理时间：">
              <el-input v-model="handleDetailInfo.handleTime" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="第二环节处理意见：">
              <el-input v-model="handleDetailInfo.handleComment" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="回函文件：">
              <div v-for="file in appealFinishFile">
                <el-link :underline="false" type="info" :href="file.fileUrl" target="_blank">{{file.fileName}}</el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDetailInfoVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="审核" width="500px" :visible.sync="verifyAppealVisible" :close-on-click-modal="false">
      <el-form :model="verifyAppeal" ref="verifyInfoForm" :rules="verifyInfoRules" label-width="100px">
        <el-form-item label="审核结果：" prop="status">
          <el-select v-model="verifyAppeal.status" placeholder="请选择审核结果" style="width: 100%">
            <el-option
              v-for="item in verifyStatus"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="verifyAppealVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmVerify">处 理</el-button>
      </div>
    </el-dialog>
    <el-dialog title="延期报告文件" width="500px" :visible.sync="handleDelayVisible" :close-on-click-modal="false">
      <div v-for="(file,index) in appealDelayFile">
        <el-link :underline="false" type="info" :href="file.fileUrl" target="_blank">{{index+1}}. {{file.fileName}}</el-link>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import Common from '@/components/common/Common'
  import { Table } from '@/components/common/Table'
  import { currentUser,enterpriseAppealDelayFile,listAppealDelayApply, verifyAppealDelay, enterpriseAppealFile,enterpriseAppealFinishFile, portalDictionary,portalParkList, listOrg, listOrgUser, detailUser} from '@/api/restapi.js'
  export default {
    mixins: [Table],
    data() {
      return {
        user: Common.user,
        appealPayTypeList: [],
        organizationList: [],
        enterpriseSizeList: [],
        enterpriseTypeList: [],
        appealFinishFile: [],
        appealDelayFile: [],
        enterpriseIndustryList: [],
        antiEnterpriseTypeList: [],
        userList: [],
        appealFile: [],
        parkList: [],
        verifyAppealVisible: false,
        verifyAppeal: {
        },
        verifyInfoRules: {
          status: [
            { required: true, message: '请选择审核结果', trigger: 'change' }
          ]
        },
        verifyStatus: [{
          code: 'pass',
          name: '通过'
        },{
          code: 'deny',
          name: '拒绝'
        }],
        handleDetailInfo: {
          appealIds: [],
          firstName: '',
          secondName: '',
          organizationNames: ''
        },
        appealTypeList: [],
        handleDetailInfoVisible: false,
        handleDelayVisible: false
      }
    },
    mounted () {
      portalDictionary('appeal_pay_type').then(res => {
        if (res.data.code === 0) {
          this.appealTypeList = res.data.data
          this.appealPayTypeList = res.data.data
        }
      })
      portalDictionary('enterprise_size').then(res => {
        if (res.data.code === 0) {
          this.enterpriseSizeList = res.data.data
        }
      })
      portalDictionary('enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.enterpriseTypeList = res.data.data
        }
      })
      portalDictionary('enterprise_industry').then(res => {
        if (res.data.code === 0) {
          this.enterpriseIndustryList = res.data.data
        }
      })
      portalDictionary('anti_enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.antiEnterpriseTypeList = res.data.data
        }
      })
      listOrg(1, 99999).then(res => {
        if(res.data.code === 0){
          this.organizationList = res.data.data.list
        }
      })
      this.queryParkAsync('')
    },
    methods: {
      handleDelayView (col, row) {
        this.handleDelayVisible = true
        this.appealDelayFile = []
        enterpriseAppealDelayFile(row.delayApplyId).then(res => {
          if (res.data.code === 0){
            this.appealDelayFile = res.data.data
          }
        })
      },
      beforeTableSearch () {
        if (this.user.role){
          return true
        }else {
          currentUser().then(res => {
            if (res.data.code === 0) {
              this.user = res.data.data
              this.searchList()
            }
          })
          return false
        }
      },
      handleVerify (index,row){
        this.verifyAppealVisible = true
        this.verifyAppeal = Object.assign({},{
          id: row.delayApplyId,
          appealId: row.id
        })
      },
      confirmVerify() {
        let isValid = true
        this.$refs['verifyInfoForm'].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (isValid) {
          verifyAppealDelay(this.verifyAppeal).then(res => {
            if (res.data.code === 0){
              this.verifyAppealVisible = false
              this.$message({
                type: 'success',
                message: '审核成功'
              })
              this.searchList()
            }else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        }
      },
      queryParkAsync (queryString, cb) {
        portalParkList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            // cb(names)
            this.parkList = names
          }
        })
      },
      downloadOpinion (url) {
        window.open(url)
      },
      getOrgName (orgId) {
        let name = ''
        this.organizationList.some(org => {
          if (org.id === orgId) {
            name = org.name
            return true
          }
        })
        return name
      },
      handleOrgChange (val) {
        listOrgUser({
          orgIds: val
        }).then(res => {
          if (res.data.code === 0) {
            this.userList = []
            res.data.data.forEach(ug => {
              this.userList.push({
                label: this.getOrgName(ug.orgId),
                orgId: ug.orgId,
                options: ug.userInfos
              })
            })
          }
        })
      },
      handleDetail (col, row) {
        this.handleDetailInfo = Object.assign({firstName:'',secondName:''}, row)
        this.appealFile = []
        enterpriseAppealFile(row.id).then(res => {
          if (res.data.code === 0) {
            this.appealFile = res.data.data
          }
        })
        enterpriseAppealFinishFile(row.id).then(res => {
          if (res.data.code === 0){
            this.appealFinishFile = res.data.data
          }
        })
        detailUser(this.handleDetailInfo.deliveryUser).then(res => {
          if (res.data.code === 0) {
            this.handleDetailInfo.firstName = res.data.data.name + '(' + res.data.data.organization + ')'
          }
        })
        detailUser(this.handleDetailInfo.handleUser).then(res => {
          if (res.data.code === 0) {
            this.handleDetailInfo.secondName = res.data.data.name + '(' + res.data.data.organization + ')'
          }
        })
        this.handleDetailInfoVisible = true
      },
      searchMethod () {
        if (this.user.role==='admin') {
          this.searchInfo.status = 'apply'
        }
        return listAppealDelayApply(this.pageInfo.page,this.pageInfo.size, this.searchInfo)
      },
      addMethod () {
      },
      beforeUpdate () {
      },
      updateMethod () {
      },
      statusFortmatter (row, col) {
        let name = ''
        if (row.status === 'unhandle') {
          name = '不处理'
        }else if (row.status === 'finish'){
          name = '已完成'
        }
        if (row.status === 'distribution') {
          name = '已分配'
        }
        if (row.status === 'wait') {
          name = '待处理'
        }
        if (row.status === 'withdraw') {
          name = '退回'
        }
        return name
      },
      contentFormatter (row, col) {
        return row.appealContent.substring(0,10) + (row.appealContent.length<10?'':'...')
      },
      delayStatusFormatter (row,col) {
        let name = ''
        if (row.delayStatus==='apply'){
          name = '待审核'
        }
        if (row.delayStatus==='pass'){
          name = '审核通过'
        }
        if (row.delayStatus==='deny'){
          name = '审核失败'
        }
        return name
      },
      appealTypeFormatter (row, col) {
        let name = ''
        this.appealTypeList.forEach(a => {
          if (a.code === row.appealType) {
            name = a.name
          }
        })
        return name
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
  .payInfoTag {
    color: #0068BC;
    border: 1px solid #0068BC;
    font-size: 15px;
    margin-left: 50px;
    border-radius: 5px;
    background: #f4fbfe;
    padding: 3px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnterpriseAppealPayDelay.vue